import { registerQuery, useQuery } from 'data-fetching-client';
import Raven from 'raven-js';

import { startOAuth } from '../integrations/Trello/TrelloApi';

const GET_TRELLO_REDIRECT_URL = registerQuery({
  fieldName: 'trelloRedirectUrl',
  fetcher: startOAuth,
});

type TUseTrelloRedirectUrlArgs = {
  skip?: boolean;
};

export const useTrelloRedirectUrl = ({
  skip = false,
}: TUseTrelloRedirectUrlArgs) => {
  const { data, loading, error } = useQuery(GET_TRELLO_REDIRECT_URL, {
    onError: (err) => {
      Raven.captureException(err, {
        extra: { message: 'Error on starting OAuth for Trello' },
      });
    },
    skip,
  });

  return {
    redirectUrl: data ? data.trelloRedirectUrl?.redirectUrl : '',
    loading,
    error,
  };
};
